import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Popover, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import {UpdatePatrimonyCmd} from '../models'
import {UPDATE_PATRIMONY_CMD_UPDATED, sendUpdatePatrimonyCmd, loadPatrimony} from '../actions'
import i18n from '../i18n'

class UpdatePatrimonyPopover extends Component {
    static displayName = 'ReferencePatrimonyModal'

    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {form, patrimony} = this.props

        form().onChange({
            ref: patrimony.ref,
            label: patrimony.label
        })
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props

        return dispatch(sendUpdatePatrimonyCmd()).then(() => {
            return dispatch(loadPatrimony())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, patrimony, onHide, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        return (
            <Popover
                title={i18n.updatePatrimony}
                {...others}>
                <form className='form-horizontal'>
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='reference'
                        label={requiredLabel(i18n.reference)}
                        {...form.ref()} />
                    <Input
                        labelClassName='col-sm-3'
                        wrapperClassName='col-sm-9'
                        type='text'
                        name='label'
                        label={requiredLabel(i18n.label)}
                        {...form.label()} />
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.save}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

UpdatePatrimonyPopover = connectForm({
    target: 'cmd',
    schema: UpdatePatrimonyCmd.schema,
    action: UPDATE_PATRIMONY_CMD_UPDATED
})(UpdatePatrimonyPopover)

UpdatePatrimonyPopover = connect((state) => ({
    cmd: state.patrimony.updatePatrimonyCmd,
    patrimony: state.patrimony.patrimony
}))(UpdatePatrimonyPopover)

export default UpdatePatrimonyPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/UpdatePatrimonyPopover.js